var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgView = function SvgView(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.7 669.9c-103.5 0-187.1-83.6-187.1-187.1s83.6-187.1 187.1-187.1 187.1 83.6 187.1 187.1-83.6 187.1-187.1 187.1m0-497.6C191.2 172.3 4.1 482.8 4.1 482.8s187.1 310.5 497.6 310.5 497.6-310.5 497.6-310.5-187.1-310.5-497.6-310.5m0 185.7c-13.3 0-25.2 2.7-35.8 6.6 21.2 9.3 35.8 30.5 35.8 55.7 0 34.5-27.9 62.4-62.4 62.4-25.2 0-46.4-14.6-55.7-35.8-4 11.9-6.6 23.9-6.6 35.8 0 69 55.7 124.7 124.7 124.7s124.7-55.7 124.7-124.7S570.7 358 501.7 358"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgView);
export default ForwardRef;